import { Model } from "@vuex-orm/core";
import Customer from "./Customer";
import User from "./User";
import ContactInfo from "./ContactInfo";

export default class Message extends Model {
  static entity = "messages";

  static fields() {
    return {
      createdAt: this.attr(),
      updatedAt: this.attr(),
      id: this.attr(),
      isDirty: this.boolean(false),
      customerId: this.number(0),
      messageType: this.string("sms"),
      messageBody: this.attr(),
      media: this.attr().nullable(),
      isInbound: this.boolean(true),
      isReviewRequest: this.boolean(false),
      userId: this.number(0),
      contactInfoId: this.number(0),
      customer: this.belongsTo(Customer, "customerId"),
      user: this.belongsTo(User, "userId"),
      contactInfo: this.belongsTo(ContactInfo, "contactInfoId")
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
